// @flow
import {
  TimestampUtil,
  DateTimeUtil,
} from "../../../utils/datetime/DateTimeUtil";

import {
  DATETIME_OFFSET_FORMAT,
  isIncludeTimeOffsetInDateTimes,
} from "../../../constants";

import type { IConstraintModel } from "../../types";

/**
 */
class DatetimeFormatConstraint implements IConstraintModel {
  _type: string;
  _format: string;
  _formatNoOffset: string;
  _formatLabel: string;

  _id: string = "Constraint.DateTime.MissingValue";

  /**
   */
  constructor(type: string, format: string, formatLabel: string) {
    this._type = type;
    this._format = format;
    this._formatNoOffset = format.replace(DATETIME_OFFSET_FORMAT, "").trim();
    this._formatLabel = formatLabel;
  }

  /**
   */
  get type(): string {
    return this._type;
  }

  /**
   */
  get id(): string {
    return this._id;
  }

  /**
   */
  get format(): string {
    return this._format;
  }

  /**
   */
  get formatLabel(): string {
    return this._formatLabel;
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    if (this._id === "Constraint.DateTime.MissingOffset") {
      return "Please select ${daylight-label} or ${standard-label}";
    }
    return "Date and time should both be entered";
  }

  /**
   */
  get parameters():
    | { format: string }
    | { "daylight-label": ?string, "standard-label": ?string } {
    if (this._id === "Constraint.DateTime.MissingOffset") {
      const offsets = DateTimeUtil.getTimezoneOffsets();
      return {
        "daylight-label": offsets.daylight?.label,
        "standard-label": offsets.standard?.label,
      };
    }
    return { format: this.formatLabel };
  }

  /**
   */
  get formatUtil(): typeof TimestampUtil | typeof DateTimeUtil {
    if (this.type === "timestamp") {
      return TimestampUtil;
    }

    return DateTimeUtil;
  }

  /**
   */
  validate(value: string): boolean {
    if (!value) {
      return false;
    }

    if (this.formatUtil.hasFormat(value, this.format)) {
      return true;
    }

    if (isIncludeTimeOffsetInDateTimes()) {
      const hasDateTime = this.formatUtil.hasFormat(
        value,
        this._formatNoOffset,
      );
      if (!hasDateTime) {
        this._id = "Constraint.DateTime.MissingValue";
        return false;
      } else if (!/[+-](0\d|1[0-4]):[0-5]\d/.test(value)) {
        this._id = "Constraint.DateTime.MissingOffset";
        return false;
      }
    }

    return false;
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default DatetimeFormatConstraint;
